import { render, staticRenderFns } from "./AdminPages.vue?vue&type=template&id=dcbeef26"
import script from "./AdminPages.vue?vue&type=script&lang=js"
export * from "./AdminPages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports